import React from "react";
import { colors, useMediaQuery } from "../../../Styles";
import { CheckBox, CheckStyles } from "../..";

import { DataParameters, ReportTemplate } from "../../../Assets/TestData/reportTemplates";

interface Lvl3_Props {
  report?: ReportTemplate
}

export default function ReportModalLvl3({report}:Lvl3_Props) {
  const mobileXs = useMediaQuery(`(max-width: 690px)`);
  // const dataParameter: DataParameter[] = ["Location", "Group", "Condition"]
  
  return(
      <div style={{width: mobileXs ? "280px" : "600px"}}>
        <div style={{borderTop: "2px solid"+colors.blueDarkSecondary, borderBottom: "2px solid"+colors.blueDarkSecondary, padding: "10px 0px", maxHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{width: "fit-content", display: "grid", gridTemplateColumns: mobileXs ? "1fr 1fr" : "1fr 1fr 1fr", gridTemplateRows: mobileXs ? "1fr 1fr" : "", columnGap: mobileXs ? "50px" : "100px", rowGap: "10px"}}>
            {/* TODO: Translate data parameters */}
            {DataParameters.map((param, index) => (
                <CheckBox key={index} text={param} checkStyle={CheckStyles.blue} isChecked={report?.dataParameter?.includes(param)}/>
            ))}
          </div>
        </div>
      </div>
  )
}